export const SL_WEB_AUS_LAUNCH_MODAL = 'sl_web_aus_launch_modal';
export const SL_WEB_CONDITION_VARIATION = 'SL_ios_web_spot_condition_colors';
